import React from 'react'
import AppContext from 'AppContext'
import { env } from 'components/Helpers'

const Monitoring = () => {
  const token = window.localStorage.getItem('auth-token')
  const { operator } = React.useContext(AppContext)

  // We may have to wait for AppContext to be available
  if (!operator.id) {
    return (
      <div className='index monitoring'>
        <p>waiting for operator...</p>
      </div>
    )
  }

  return (
    <div>
      <cl-monitoring
        mountPath={`/operators/${operator.id}/monitor`}
        apiHost={`https://donedone.${env()}.credlock.net`}
        operatorid={operator.id}
        token={token}
      />
    </div>
  )
}

const MonitoringWrapper = ({ permission, history }) => {
  return (
    <div className='monitoring-wrapper'>
      <Monitoring />
    </div>
  )
}

export default MonitoringWrapper
